<div class="relative inline-flex w-full">
  <select
    class="btn w-full appearance-none btn-outline pr-10 text-left"
    [value]="selectedItemId ?? ''"
    (change)="onItemSelectedChange($event)"
  >
    <option value="" disabled selected hidden>
      {{ 'common.filter.entities.dropdown.choose' | translate }}
    </option>

    @for (item of items(); track item.id) {
      <option [value]="item.id">{{ item.name }}</option>
    }
  </select>

  <span class="pointer-events-none absolute top-1/2 right-3 -translate-y-1/2">
    <svg class="h-4 w-4" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        d="M6 8l4 4 4-4"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </span>
</div>
